import { render, staticRenderFns } from "./AltTableOlgunluk.vue?vue&type=template&id=6dd359c7"
import script from "./AltTableOlgunluk.vue?vue&type=script&lang=js"
export * from "./AltTableOlgunluk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports